import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {OrderStatus} from "../../../enums/OrderStatus";
import {OrdersService} from "../../../service/orders.service";
import {Order} from "../../../models/Order";
import {GetPageUtil} from "../../get-page-util";

@Component({
  selector: 'app-admin-orders',
  templateUrl: './admin-orders.component.html',
  styleUrl: './admin-orders.component.scss'
})
export class AdminOrdersComponent implements OnInit {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ordersContainer') ordersContainer!: ElementRef;

  pageSize: number = 10;
  currentPage: number = 0;
  totalPageCount: number | any;
  isLoading: boolean = false;
  orders: Order[] = [];
  selectedStatus: string = '';
  searchTerm!: string;
  totalOrdersCount!: number;
  private getPageUtil = new GetPageUtil()

  constructor(private orderService: OrdersService) {
  }

  orderStatusList = [
    {
      value: OrderStatus.DELIVERED,
      viewValue: 'Delivered',
      pastValue: 'Delivered',
      nextStatuses: []
    },
    {
      value: OrderStatus.PAID,
      viewValue: 'Paid',
      pastValue: 'Paid',
      nextStatuses: [
        {value: OrderStatus.IN_DELIVERY, viewValue: 'In Delivery'},
        {value: OrderStatus.CANCELLED, viewValue: 'Cancel'}
      ]
    }, {
      value: OrderStatus.IN_DELIVERY,
      viewValue: 'In Delivery',
      pastValue: 'In Delivery',
      nextStatuses: [
        {value: OrderStatus.DELIVERED, viewValue: 'Delivered'},
        {value: OrderStatus.CANCELLED, viewValue: 'Cancel'}
      ]
    },
    {
      value: OrderStatus.NEW,
      viewValue: 'New',
      pastValue: 'New',
      nextStatuses: []
    },

    {
      value: OrderStatus.CANCELLED,
      viewValue: 'Canceled',
      pastValue: 'Canceled',
      nextStatuses: []
    },
    {
      value: OrderStatus.UNPAID,
      viewValue: 'Unpaid',
      pastValue: 'Unpaid',
      nextStatuses: []
    }
  ];

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders(status?: OrderStatus | string, searchTerm?: string): void {
    if (this.isLoading) return;
    this.isLoading = true;
    this.orderService.getOrders(this.currentPage, this.pageSize, status, searchTerm).subscribe({
      next: (response) => {
        this.totalOrdersCount = response.totalElements
        this.orders = response.content;
        this.totalPageCount = response.totalPages;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  filterOrdersByStatus(): void {
    this.currentPage = 0;
    this.orders = [];
    this.loadOrders(this.selectedStatus);
  }

  updateOrderStatus(order: Order) {
    this.orderService.updateOrderStatus(order.id, order.orderStatus).subscribe({
      next: (response) => {
      },
      error: (error) => {
        alert(error.message);
      }
    });
  }

  getStatusOptions(order: Order): { value: OrderStatus, viewValue: string }[] {
    const currentStatus = this.orderStatusList.find(status => status.value === order.orderStatus);
    if (!currentStatus) return [];
    return currentStatus.nextStatuses.map(nextStatus => {
      return {
        value: nextStatus.value,
        viewValue: nextStatus.viewValue
      };
    });
  }

  getPastValue(status: OrderStatus): string | undefined {
    const statusObj = this.orderStatusList.find(s => s.value === status);
    return statusObj?.pastValue;
  }

  goToPage(page: number) {
    if (page >= 0 && page < this.totalPageCount) {
      this.currentPage = page;
      this.loadOrders(this.selectedStatus, this.searchTerm);
    }
  }
  getPageNumbers(): number[] {
    return this.getPageUtil.getPageNumbers(this.currentPage, this.totalOrdersCount, this.pageSize);
  }

  onSearch(searchTerm: string): void {
    this.searchTerm = searchTerm.trim();
    this.currentPage = 0;
    this.orders = [];
    const shouldSearch = this.searchTerm.length > 2;
    this.loadOrders(this.selectedStatus, shouldSearch ? this.searchTerm : undefined);
  }

  onEnterKeyPressed(searchTerm: string) {
    this.onSearch(searchTerm);
  }

  protected readonly OrderStatus = OrderStatus;

}
